import React from "react";

interface LogoProps {
  className?: string;
  size?: number;
  showText?: boolean;
}

export const HarbourLogo: React.FC<LogoProps> = ({
  className = "",
  size = 40,
  showText = false,
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-sm"
      >
        {/* External Hexagon (The Docking Frame) */}
        <path
          d="M50 5L89.5 27.5V72.5L50 95L10.5 72.5V27.5L50 5Z"
          stroke="#2D2D3F"
          strokeWidth="8"
          strokeLinejoin="round"
        />

        {/* Isometric Cube (The Asset/Container) */}
        {/* Top Face */}
        <path d="M50 25L75 38L50 51L25 38L50 25Z" fill="#E94E24" />
        {/* Left Face */}
        <path d="M25 38V64L50 77V51L25 38Z" fill="#F9B21C" />
        {/* Right Face */}
        <path d="M50 51V77L75 64V38L50 51Z" fill="#2D2D3F" />

        {/* Gantry/Crane Detail lines */}
        <path
          d="M10.5 27.5L25 38"
          stroke="#2D2D3F"
          strokeWidth="2"
          strokeDasharray="4 4"
        />
        <path
          d="M89.5 27.5L75 38"
          stroke="#2D2D3F"
          strokeWidth="2"
          strokeDasharray="4 4"
        />
        <path
          d="M50 5L50 25"
          stroke="#2D2D3F"
          strokeWidth="2"
          strokeDasharray="4 4"
        />

        {/* Water/Port Base Waves */}
        <path
          d="M20 85Q35 80 50 85Q65 90 80 85"
          stroke="#2D2D3F"
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.3"
        />
      </svg>

      {showText && (
        <div className="flex flex-col -space-y-1">
          <span className="text-xl font-bold tracking-tight text-[#2D2D3F]">
            axetay
          </span>
          <span className="text-xs font-black uppercase tracking-[0.2em] text-[#E94E24]">
            Harbour
          </span>
        </div>
      )}
    </div>
  );
};
